/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Job/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Job({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/Settings/Content/Job"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let providerAccountIsFeeAcknowledgedOriginalValueData = fromData.useDataValue({ viewPath,
context: 'provider_account',
path: 'is_fee_acknowledged_original',
})
let providerAccountFeeModeValueData = fromData.useDataValue({ viewPath,
context: 'provider_account',
path: 'fee_mode',
})
let providerAccountHasChangesValueData = fromData.useDataValue({ viewPath,
context: 'provider_account',
path: 'has_changes',
})
let aggregateData = fromHelpers.getView(providerAccountIsFeeAcknowledgedOriginalValueData, providerAccountFeeModeValueData, providerAccountHasChangesValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}